/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if ('__EXCLUDE_SLDS_ICONS__' === '__INCLUDE_SLDS_ICONS__') {
  icons = {
    ai: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.075.006A5.074 5.074 0 00.002 5.08v53.841a5.073 5.073 0 005.073 5.074h45.774a5.074 5.074 0 005.074-5.074V20.316L37.02.006H5.075z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFC35E"
      }, {
        "d": "M55.923 20.357v.999h-12.8s-6.312-1.26-6.128-6.707c0 0 .253 5.708 6.003 5.708h12.925z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFB446"
      }, {
        "d": "M37.02.006v14.56c0 1.656 1.104 5.792 6.104 5.792h12.8L37.02.006z",
        "opacity": ".5",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }, {
        "d": "M20.136 53.923a.776.776 0 01-.72-.486l-.9-2.287h-5.978l-.9 2.287a.776.776 0 01-.72.486.804.804 0 01-.811-.792c0-.09.018-.198.054-.288l4.141-10.335a1.304 1.304 0 011.225-.811c.522 0 .99.324 1.188.811l4.177 10.335c.036.09.054.198.054.288 0 .36-.324.792-.81.792zm-4.61-10.569l-2.557 6.463h5.095l-2.538-6.463zm8.513 10.569a.73.73 0 01-.738-.738V42.417c0-.396.324-.72.774-.72.396 0 .72.324.72.72v10.767a.734.734 0 01-.756.739z",
        "fill": "#fff"
      }]
    },
    attachment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.113-.026A5.074 5.074 0 00.039 5.048v53.841a5.073 5.073 0 005.074 5.074h45.773a5.074 5.074 0 005.074-5.074V20.284L37.059-.026H5.113z",
          "fill": "#8199AF"
        }, {
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#617F9B"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": {
        "d": "M26.6 41.467c1.134-1.134 1.134-2.986 0-4.12s-2.986-1.134-4.12 0l-9.167 9.167c-1.134 1.134-1.134 2.986 0 4.12s2.986 1.134 4.12 0l5.625-5.602c.324-.324.324-.856 0-1.181s-.856-.324-1.181 0l-3.542 3.519a1.204 1.204 0 01-1.759 0 1.204 1.204 0 010-1.759l3.519-3.542c1.319-1.296 3.426-1.296 4.722 0 1.296 1.319 1.296 3.426 0 4.722l-5.625 5.625c-2.106 2.106-5.532 2.106-7.662 0-2.106-2.129-2.106-5.555 0-7.662l9.166-9.167c2.13-2.129 5.556-2.129 7.662 0 2.129 2.106 2.129 5.532 0 7.662l-.903.902a4.968 4.968 0 00-.926-2.616l.071-.068z",
        "fill": "#fff"
      }
    },
    audio: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.151.012A5.073 5.073 0 00.078 5.085v53.842A5.073 5.073 0 005.151 64h45.774A5.074 5.074 0 0056 58.927V20.321L37.097.012H5.151z",
          "fill": "#379FD3"
        }, {
          "d": "M56 20.357v1H43.2s-6.312-1.26-6.128-6.707c0 0 .208 5.707 6.003 5.707H56z",
          "fill": "#2987C8"
        }, {
          "d": "M37.097.006v14.561c0 1.656 1.104 5.791 6.104 5.791h12.8L37.097.006z",
          "opacity": ".5",
          "fill": "#fff"
        }, {
          "d": "M29.798 34.036L15.633 35.85v13.438c-.738-.205-1.628-.243-2.531-.064-2.009.394-3.325 1.702-2.938 2.918.386 1.215 2.325 1.88 4.333 1.48 1.764-.348 2.994-1.397 3.005-2.473h.002v-10.74l10.422-1.288v8.306c-.75-.212-1.655-.251-2.572-.068-2.03.399-3.357 1.718-2.969 2.947.389 1.229 2.35 1.897 4.379 1.499 1.849-.366 3.116-1.494 3.031-2.621V34.036z",
          "fill": "#fff"
        }]
      }
    },
    box_notes: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#277A84",
        "d": "M5.112.011A5.074 5.074 0 00.039 5.085v53.841A5.074 5.074 0 005.112 64h45.775a5.074 5.074 0 005.074-5.074V20.321L37.057.011H5.112z"
      }, {
        "fill": "#1E5B60",
        "d": "M55.96 20.377v1H43.161s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707H55.96z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37.059.025v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.059.025z"
      }, {
        "fill": "#FFF",
        "d": "M27.094 39.334l2.105-2.104H10.495s-.361.016-.362.401 0 1.159 0 1.347c0 .187.182.355.375.355l16.586.001zM19.768 46.602l2.104-2.104H10.495s-.361.016-.362.401v1.347c0 .187.182.356.375.356h9.26zM14.708 53.904l.268-2.104h-4.48s-.361.017-.362.402 0 1.16 0 1.346c0 .187.182.356.375.356h4.199zM15.588 53.873s1.672-.03 2.015-.112c.342-.082.406-.146.531-.271l13.104-13.104s-.494.42-1.592-.682c-.869-.87-.487-1.402-.487-1.402s-12.75 12.729-12.99 12.988c-.24.26-.252.404-.274.509-.021.105-.307 2.074-.307 2.074z"
      }, {
        "fill": "#FFF",
        "d": "M30.742 36.714c-.201.201-.96.938-1.059 1.058-.097.121-.184.227-.104.58.079.353.682 1.354 1.656 1.629 0 0 .299.107.541-.133.24-.242 1.092-1.093 1.092-1.093s.204-.172.042-.621c-.163-.448-.81-1.247-1.582-1.539-.387-.148-.586.119-.586.119z"
      }]
    },
    csv: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.106 0A5.074 5.074 0 00.033 5.074v53.841a5.073 5.073 0 005.073 5.074H50.88a5.074 5.074 0 005.074-5.074V20.31L37.051 0H5.106z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#45B058"
      }, {
        "d": "M20.306 43.197a.784.784 0 01.198.522c0 .378-.306.72-.703.72a.638.638 0 01-.504-.234c-.702-.846-1.891-1.387-3.007-1.387-2.629 0-4.627 2.017-4.627 4.88 0 2.845 1.999 4.879 4.627 4.879a3.97 3.97 0 003.007-1.369.697.697 0 01.504-.233c.415 0 .703.359.703.738 0 .18-.072.36-.198.504-.937.972-2.215 1.693-4.015 1.693-3.457 0-6.176-2.521-6.176-6.212s2.719-6.212 6.176-6.212c1.8.001 3.096.721 4.015 1.711zm6.802 10.714c-1.782 0-3.187-.594-4.213-1.495a.71.71 0 01-.234-.54c0-.361.27-.757.702-.757.144 0 .306.036.432.144.828.739 1.98 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.071 0-3.097-7.112-1.386-7.112-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.467 3.853 1.278a.73.73 0 01.252.54c0 .36-.306.72-.703.72a.68.68 0 01-.432-.162c-.882-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636.001 1.748-1.187 3.531-4.428 3.531zm16.994-11.254l-4.159 10.335a1.31 1.31 0 01-1.188.81h-.036a1.316 1.316 0 01-1.207-.81L33.37 42.657a.746.746 0 01-.054-.288c0-.36.323-.793.81-.793.306 0 .594.18.72.486l3.889 9.992 3.889-9.992a.767.767 0 01.72-.486.803.803 0 01.758 1.081z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M56.001 20.357v1h-12.8s-6.312-1.26-6.128-6.707c0 0 .208 5.707 6.003 5.707h12.925z",
          "fill": "#349C42"
        }, {
          "d": "M37.098.006v14.561c0 1.656 1.104 5.791 6.104 5.791h12.8L37.098.006z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    eps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.106.009A5.074 5.074 0 00.033 5.083v53.841a5.073 5.073 0 005.073 5.074H50.88a5.074 5.074 0 005.074-5.074V20.319L37.052.009H5.106z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFC35E"
      }, {
        "d": "M17.45 53.912h-6.248a1.085 1.085 0 01-1.081-1.081v-9.849c0-.595.486-1.081 1.081-1.081h6.248c.36 0 .648.288.648.685a.645.645 0 01-.648.647h-5.833v3.871h5.708c.36 0 .648.288.648.685 0 .36-.288.648-.648.648h-5.708v4.141h5.833c.36 0 .648.288.648.648 0 .397-.288.686-.648.686zm8.189-4.772h-3.331v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.982c0-.595.486-1.081 1.081-1.081h3.745c2.413 0 3.763 1.657 3.763 3.619-.001 1.963-1.387 3.62-3.764 3.62zm-.18-5.906h-3.151v4.573h3.151c1.422 0 2.395-.936 2.395-2.287 0-1.35-.973-2.286-2.395-2.286zm10.259 10.893c-1.782 0-3.187-.594-4.213-1.495a.71.71 0 01-.234-.54c0-.361.27-.757.702-.757.144 0 .306.036.432.144.829.739 1.981 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.071 0-3.097-7.112-1.386-7.112-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.468 3.853 1.279a.73.73 0 01.252.54c0 .36-.306.72-.702.72a.68.68 0 01-.432-.162c-.882-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636.001 1.748-1.188 3.53-4.429 3.53z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M56 20.357v1H43.201c-2.438 0-6.312-1.26-6.128-6.707 0 0 .208 5.707 6.003 5.707H56z",
          "fill": "#FFB446"
        }, {
          "d": "M37.097.006v14.561c0 1.656 1.104 5.791 6.104 5.791H56L37.097.006z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    excel: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112.006A5.074 5.074 0 00.039 5.08v53.841a5.073 5.073 0 005.073 5.074h45.774a5.074 5.074 0 005.074-5.074V20.316L37.058.006H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#45B058"
      }, {
        "d": "M19.429 53.938a.64.64 0 01-.54-.27l-3.728-4.97-3.745 4.97a.641.641 0 01-.54.27.71.71 0 01-.72-.72c0-.144.035-.306.144-.432l3.89-5.131-3.619-4.826a.722.722 0 01-.145-.414c0-.342.288-.72.721-.72.216 0 .432.108.576.288l3.438 4.628 3.438-4.646a.643.643 0 01.541-.27c.378 0 .738.306.738.72a.695.695 0 01-.127.414l-3.619 4.808 3.891 5.149a.7.7 0 01.125.414c0 .396-.324.738-.719.738zm9.989-.126h-5.455a1.083 1.083 0 01-1.081-1.08V42.415c0-.396.324-.72.774-.72.396 0 .721.324.721.72V52.48h5.041c.359 0 .648.288.648.648 0 .396-.289.684-.648.684zm6.982.216c-1.782 0-3.188-.594-4.213-1.495a.71.71 0 01-.234-.54c0-.36.27-.756.702-.756.144 0 .306.036.433.144.828.738 1.98 1.314 3.367 1.314 2.143 0 2.826-1.152 2.826-2.071 0-3.097-7.111-1.386-7.111-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.468 3.853 1.278a.73.73 0 01.253.54c0 .36-.307.72-.703.72a.676.676 0 01-.432-.162c-.883-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636 0 1.748-1.188 3.53-4.43 3.53z",
        "fill": "#fff"
      }, {
        "d": "M55.953 20.352v1H43.152s-6.312-1.26-6.127-6.707c0 0 .207 5.707 6.002 5.707h12.926z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#349C42"
      }, {
        "d": "M37.049 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.801L37.049 0z",
        "opacity": ".5",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }]
    },
    exe: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112.025A5.074 5.074 0 00.039 5.099V58.94a5.073 5.073 0 005.073 5.074h45.774a5.074 5.074 0 005.074-5.074V20.335L37.058.025H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8199AF"
      }, {
        "d": "M17.455 53.919h-6.247a1.084 1.084 0 01-1.081-1.081V42.99c0-.594.486-1.08 1.081-1.08h6.247c.361 0 .648.288.648.684 0 .36-.287.648-.648.648h-5.833v3.871h5.708c.359 0 .648.288.648.685 0 .36-.289.648-.648.648h-5.708v4.141h5.833c.361 0 .648.288.648.648.001.396-.287.684-.648.684zm12.098.126a.643.643 0 01-.541-.27l-3.727-4.97-3.746 4.97a.64.64 0 01-.539.27.712.712 0 01-.721-.72c0-.144.036-.306.145-.432l3.889-5.131-3.619-4.825a.725.725 0 01-.145-.415c0-.342.289-.72.721-.72a.75.75 0 01.576.288l3.439 4.627 3.438-4.646a.641.641 0 01.54-.27c.379 0 .738.306.738.72a.694.694 0 01-.126.415l-3.618 4.808 3.889 5.149a.7.7 0 01.126.414c0 .396-.324.738-.719.738zm10.78-.126h-6.247a1.084 1.084 0 01-1.081-1.081V42.99c0-.594.486-1.08 1.081-1.08h6.247c.36 0 .648.288.648.684 0 .36-.288.648-.648.648H34.5v3.871h5.707c.36 0 .648.288.648.685 0 .36-.288.648-.648.648H34.5v4.141h5.833c.36 0 .648.288.648.648 0 .396-.288.684-.648.684z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.961 20.377v1H43.162s-6.312-1.26-6.129-6.708c0 0 .208 5.708 6.004 5.708h12.924z",
          "fill": "#617F9B"
        }, {
          "d": "M37.059.025v14.561c0 1.656 1.104 5.792 6.104 5.792h12.799L37.059.025z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    flash: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112.009A5.074 5.074 0 00.039 5.083v53.841a5.073 5.073 0 005.073 5.074h45.775a5.074 5.074 0 005.074-5.074V20.319L37.057.009H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#E53C3C"
      }, {
        "d": "M17.466 43.105h-5.833v3.871h5.708c.36 0 .648.288.648.685 0 .36-.288.648-.648.648h-5.708v4.843a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.854c0-.594.486-1.081 1.081-1.081h6.248c.36 0 .648.288.648.685a.648.648 0 01-.65.647zm9.558 10.678h-5.456a1.085 1.085 0 01-1.081-1.081V42.385c0-.396.324-.72.774-.72.396 0 .72.324.72.72V52.45h5.042c.36 0 .648.288.648.648.001.397-.287.685-.647.685zm12.222.108a.776.776 0 01-.72-.486l-.9-2.287h-5.978l-.9 2.287a.776.776 0 01-.72.486.804.804 0 01-.811-.792c0-.09.018-.198.054-.288l4.141-10.335a1.304 1.304 0 011.225-.811c.522 0 .99.324 1.188.811l4.177 10.335c.036.09.054.198.054.288 0 .359-.324.792-.81.792zm-4.609-10.569l-2.557 6.464h5.095l-2.538-6.464z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.961 20.346v1H43.162s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#DE2D2D"
        }, {
          "d": "M37.059-.006v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.059-.006z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M51.48 15.46A4.52 4.52 0 0156 20v31a4.52 4.52 0 01-4.52 4.52h-47A4.52 4.52 0 010 51V13a4.52 4.52 0 014.52-4.48H16c3.82 0 4.23 1.14 6.74 4.45 2.07 2.74 7.11 2.49 10.39 2.49z",
        "fill": "#003462"
      }, {
        "d": "M51.48 18.12H9.24a4.52 4.52 0 00-4.52 4.52v2.84L9.19 19h42.35L56 25.49v-2.85a4.52 4.52 0 00-4.52-4.52z",
        "fill": "#87c8f2"
      }, {
        "d": "M4.57 55.48h46.91A4.52 4.52 0 0056 51V23.48A4.52 4.52 0 0051.48 19H9.25a4.52 4.52 0 00-4.52 4.52V51a4.65 4.65 0 01-.06.72 2.33 2.33 0 01-4.6 0 4.5 4.5 0 004.5 3.76z",
        "fill": "#00a1e0"
      }]
    },
    gdoc: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112.011A5.074 5.074 0 00.039 5.085v53.841A5.074 5.074 0 005.112 64h45.775a5.074 5.074 0 005.074-5.074V20.321L37.057.011H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#3C8CEA"
      }, {
        "d": "M10.133 37.439h21.564v2.059H10.133zm0 4.801h21.564v2.057H10.133zm0 4.801h21.564v2.057H10.133zm0 4.8h12.233v2.058H10.133z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.96 20.377v1H43.161s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707H55.96z",
          "fill": "#2D6FE4"
        }, {
          "d": "M37.058.025v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.058.025z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    gdocs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#3C8CEA",
        "d": "M5.1 0C2.3 0 0 2.3 0 5.1v53.8C0 61.7 2.3 64 5.1 64h45.8c2.8 0 5.1-2.3 5.1-5.1V20.3L37.1 0h-32z"
      }, {
        "fill": "#2D6FE4",
        "d": "M56 20.4v1H43.2s-6.4-1.3-6.2-6.7c0 0 .2 5.7 6 5.7h13z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37.1 0v14.6c0 1.6 1.1 5.8 6.1 5.8H56L37.1 0z"
      }, {
        "fill": "#FFF",
        "d": "M25.9 45.1h-7.6v2.2h5.4c-.3 3.2-2.9 4.5-5.4 4.5-3.2 0-5.9-2.5-5.9-6 0-3.4 2.6-6 5.9-6 2.5 0 4.1 1.6 4.1 1.6l1.6-1.6s-2-2.2-5.7-2.2c-4.7 0-8.3 4-8.3 8.2 0 4.2 3.4 8.3 8.4 8.3 4.4 0 7.7-3 7.7-7.5-.1-.9-.2-1.5-.2-1.5z"
      }]
    },
    gform: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#673AB7",
        "d": "M5.113-.026A5.074 5.074 0 00.039 5.048v53.841a5.073 5.073 0 005.074 5.074h45.773a5.074 5.074 0 005.074-5.074V20.284L37.059-.026H5.113z"
      }, {
        "fill": "#45317C",
        "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z"
      }, {
        "fill": "#FFF",
        "d": "M12.739 39.41c0-.4-.3-.7-.7-.7h-1.3c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h1.3c.4 0 .7-.3.7-.7v-1.3zm18.8 0c0-.4-.3-.7-.7-.7h-15.7c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h15.7c.4 0 .7-.3.7-.7v-1.3zm-18.8 6.3c0-.4-.3-.7-.7-.7h-1.3c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h1.3c.4 0 .7-.3.7-.7v-1.3zm18.8 0c0-.4-.4-.7-.8-.7h-15.5c-.4 0-.8.3-.8.7v1.3c0 .4.4.7.8.7h15.5c.4 0 .8-.3.8-.7v-1.3zm-18.8 6.2c0-.4-.3-.7-.7-.7h-1.3c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h1.3c.4 0 .7-.3.7-.7v-1.3zm18.8 0c0-.4-.3-.7-.7-.7h-15.7c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h15.7c.4 0 .7-.3.7-.7v-1.3z"
      }]
    },
    gpres: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.111.009A5.073 5.073 0 00.039 5.083v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.318L37.057.009H5.111z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#F8BE46"
      }, {
        "d": "M10.123 37.465v11.9H22.54v-11.9H10.123zm11.289 9.642h-10.16v-7.386h10.16v7.386zm.674-5.128v2.259h8.386v7.385h-10.16v-2.846h-1.129v5.104h12.419V41.979h-9.516z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.96 20.377v1H43.161s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707H55.96z",
          "fill": "#F6AD34"
        }, {
          "d": "M37.058.025v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.058.025z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    gsheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.131-.001A5.073 5.073 0 00.059 5.073v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.309L37.076-.001H5.131z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#20A971"
      }, {
        "d": "M10.107 37.466v16.419h21.521V37.466H10.107zm6.458 15.078h-4.967v-3.58h4.967v3.58zm0-5.012h-4.967v-3.579h4.967v3.579zm0-5.011h-4.967v-3.58h4.967v3.58zm13.632 10.023H18.042v-3.58h12.155v3.58zm0-5.012H18.042v-3.579h12.155v3.579zm0-5.011H18.042v-3.58h12.155v3.58z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.98 20.32v1H43.179s-6.312-1.26-6.127-6.707c0 0 .207 5.707 6.002 5.707H55.98z",
          "fill": "#189355"
        }, {
          "d": "M37.076-.031V14.53c0 1.656 1.104 5.791 6.104 5.791h12.801L37.076-.031z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    html: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.135.008A5.074 5.074 0 00.061 5.082v53.84a5.073 5.073 0 005.074 5.074H50.91a5.074 5.074 0 005.074-5.074V20.317L37.081.008H5.135z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#F7622C"
      }, {
        "d": "M18.942 50.841a.87.87 0 01-.336-.063l-7.58-3.38c-.483-.21-.798-.714-.798-1.28 0-.504.315-1.008.798-1.219l7.58-3.4a.89.89 0 011.218.84.89.89 0 01-.525.818l-7.034 3.002 7.034 2.982a.868.868 0 01.525.818c0 .546-.462.882-.882.882zm8.464-11.044l-4.43 13.291c-.126.398-.504.629-.903.629-.525 0-.924-.398-.924-.881a.75.75 0 01.063-.295l4.43-13.29a.934.934 0 01.903-.63c.525 0 .903.42.903.902l-.042.274zm10.184 7.6l-7.58 3.38a.886.886 0 01-1.218-.819c0-.357.189-.672.525-.818l7.034-2.982-7.034-3.002a.876.876 0 01-.546-.818c-.021-.547.441-.903.903-.903.105 0 .231.021.336.063l7.58 3.4c.483.211.798.715.798 1.219 0 .567-.315 1.071-.798 1.28z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.976 20.352v1H43.177s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#F54921"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    image: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.125.042A5.074 5.074 0 00.053 5.116v53.841a5.072 5.072 0 005.072 5.073H50.9a5.074 5.074 0 005.074-5.073V20.353L37.07.042H5.125z",
          "fill": "#49C9A7"
        }, {
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#37BB91"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": {
        "d": "M10.119 53.739V32.835h20.906v20.904H10.119zm18.799-18.843H12.227v12.6h16.691v-12.6zm-9.583 8.384l3.909-5.256 1.207 2.123 1.395-.434.984 5.631H13.748l3.496-3.32 2.091 1.256zm-3.856-3.64c-.91 0-1.649-.688-1.649-1.538 0-.849.739-1.538 1.649-1.538.912 0 1.65.689 1.65 1.538 0 .85-.738 1.538-1.65 1.538z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }
    },
    keynote: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.143.005A5.073 5.073 0 00.071 5.079V58.92a5.073 5.073 0 005.072 5.074h45.775a5.075 5.075 0 005.075-5.074V20.314L37.088.005H5.143z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#DB7A2A"
      }, {
        "d": "M17.819 54.013a.73.73 0 01-.54-.252l-4.429-5.275-1.207 1.368v3.403a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.489c0-.396.324-.72.774-.72.396 0 .72.323.72.72v5.6l5.186-6.067a.674.674 0 01.522-.234c.396 0 .738.306.738.702a.597.597 0 01-.162.414l-4.105 4.682 4.555 5.275a.648.648 0 01.162.433c.001.341-.288.719-.72.719zm10.926-.126h-6.248a1.084 1.084 0 01-1.081-1.08v-9.85c0-.594.486-1.08 1.081-1.08h6.248c.36 0 .648.288.648.685 0 .36-.288.648-.648.648h-5.833v3.871h5.708c.36 0 .648.288.648.684 0 .36-.288.648-.648.648h-5.708v4.142h5.833c.36 0 .648.288.648.647.001.397-.288.685-.648.685zm12.384-11.02l-4.033 5.942v4.447a.734.734 0 01-.756.738.73.73 0 01-.739-.738V48.81l-4.051-5.942a.674.674 0 01-.126-.378c0-.342.27-.72.72-.72.216 0 .468.107.612.306l3.583 5.384 3.583-5.384a.725.725 0 01.576-.288c.396 0 .738.324.738.702a.695.695 0 01-.107.377z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.976 20.352v1H43.177s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#D25B1F"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    library_folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#003462",
        "d": "M51.5 15.5c2.5 0 4.5 2 4.5 4.5v31c0 2.5-2 4.5-4.5 4.5h-47C2 55.5 0 53.5 0 51V13c0-2.5 2-4.5 4.5-4.5H16c3.8 0 4.2 1.2 6.7 4.5 2.1 2.7 7.2 2.5 10.4 2.5h18.4z"
      }, {
        "fill": "#87C8F2",
        "d": "M51.5 18.1H9.2c-2.5 0-4.5 2-4.5 4.5v2.9L9.2 19h42.3l4.5 6.5v-2.9c0-2.5-2-4.5-4.5-4.5z"
      }, {
        "fill": "#00A1E0",
        "d": "M4.6 55.5h46.9c2.5 0 4.5-2 4.5-4.5V23.5c0-2.5-2-4.5-4.5-4.5H9.3c-2.5-.1-4.5 1.9-4.6 4.4v28.3c0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3.3 2.2 2.3 3.8 4.5 3.8z"
      }],
      "g": {
        "fill": "#FFF",
        "path": [{
          "d": "M25.5 37.8h3.6v11.5h-3.6zM31.6 37.8h3.6v11.5h-3.6z"
        }, {
          "d": "M46.4 31.8l-15-6.2c-.4-.2-.7-.3-1.1-.3-.1 0-.5 0-1.1.3l-15 6.2c-.3.2-.5.5-.5.8v.9c0 .5.4.9.9.9h2.9v14c0 .5.4.9.9.9h4.5V37.8h-1.8c-.4 0-.6-.2-.6-.6V36c0-.4.2-.6.6-.6H39.4c.4 0 .6.2.6.6v1.2c0 .4-.2.6-.6.6h-1.8v11.5h4.5c.5 0 .9-.4.9-.9V34.5v-.1h2.9c.5 0 .9-.4.9-.9v-.8c.1-.4-.1-.7-.4-.9zm-16.1.5c-1.1 0-1.9-.9-1.9-1.9 0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9 0 1-.8 1.9-1.9 1.9z"
        }]
      }
    },
    link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.15.006A5.074 5.074 0 00.078 5.08v53.841a5.072 5.072 0 005.072 5.073h45.775a5.074 5.074 0 005.074-5.073V20.316L37.096.006H5.15z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#0C8FE8"
      }, {
        "d": "M28.25 35.611c-2.074-2.097-5.448-2.097-7.545 0l-3.055 3.055c-2.073 2.073-2.073 5.447 0 7.545a1.226 1.226 0 001.734 0 1.19 1.19 0 000-1.732 2.9 2.9 0 010-4.079l3.076-3.055a2.874 2.874 0 014.056 0 2.875 2.875 0 010 4.057l-1.458 1.482c.363.979.502 2.006.41 3.053l2.781-2.781c2.097-2.096 2.097-5.471.001-7.545zm-7.704 5.951a1.251 1.251 0 000 1.755 2.838 2.838 0 010 4.059l-3.055 3.053a2.874 2.874 0 01-4.058 0 2.875 2.875 0 010-4.057l1.459-1.459a7.036 7.036 0 01-.411-3.077l-2.802 2.803c-2.075 2.075-2.075 5.447 0 7.546 2.094 2.074 5.47 2.074 7.544 0l3.076-3.077c2.075-2.075 2.075-5.449 0-7.545a1.246 1.246 0 00-1.753-.001z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#0973E2"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    mp4: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.116.006A5.073 5.073 0 00.044 5.08v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.316L37.062.006H5.116z",
          "fill": "#9B64B2"
        }, {
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#824B9E"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": {
        "d": "M21.13 53.879a.73.73 0 01-.738-.738v-9.254l-4.033 9.759c-.054.144-.198.233-.378.233a.37.37 0 01-.342-.233l-4.015-9.759v9.254a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.878c0-.648.558-1.206 1.243-1.206.486 0 .99.288 1.188.756L16 50.8l3.457-8.372c.198-.468.684-.756 1.188-.756.684 0 1.243.558 1.243 1.206v10.263a.737.737 0 01-.758.738zM29.966 49h-3.331v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.842c0-.594.486-1.081 1.081-1.081h3.745c2.413 0 3.763 1.657 3.763 3.619-.001 1.964-1.387 3.62-3.764 3.62zm-.18-5.906h-3.151v4.573h3.151c1.422 0 2.395-.936 2.395-2.287 0-1.349-.973-2.286-2.395-2.286zm13.915 7.635h-1.17v2.413a.734.734 0 01-.757.738.73.73 0 01-.738-.738v-2.413h-5.077c-.378 0-.738-.324-.738-.81 0-.162.053-.342.144-.486l4.807-7.22a1.322 1.322 0 011.081-.558c.684 0 1.278.594 1.278 1.26v6.5h1.17c.342 0 .63.288.63.667a.643.643 0 01-.63.647zm-2.665-7.581l-4.213 6.266h4.213v-6.266z",
        "fill": "#fff"
      }
    },
    overlay: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.15.008A5.073 5.073 0 00.078 5.082v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.317L37.096.008H5.15z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#A382D8"
      }, {
        "d": "M10.123 34.515v14.081h14.694V34.515H10.123zm5.344 5.343v14.081h14.694V39.858H15.467z",
        "fill": "#fff"
      }, {
        "fill": "#CBBBEF",
        "d": "M15.467 39.858h9.351v8.737h-9.351z"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#8C62CE"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    pack: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.15.012A5.073 5.073 0 00.078 5.086v53.841A5.073 5.073 0 005.15 64h45.775A5.074 5.074 0 0056 58.927V20.321L37.096.012H5.15z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#4E74B7"
      }, {
        "d": "M29.187 40.872v11.917c0 .662-.529 1.191-1.191 1.191H11.311a1.186 1.186 0 01-1.191-1.191V40.872c0-.133.021-.265.065-.375l1.59-4.768a1.184 1.184 0 011.125-.816h13.507c.508 0 .971.331 1.125.816l1.59 4.768c.043.11.065.242.065.375zm-2.45 0l-1.191-3.575H13.76l-1.191 3.575h14.168z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#3A57A5"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    pages: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.111-.006A5.073 5.073 0 00.039 5.068v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.304L37.057-.006H5.111z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#6A6AE2"
      }, {
        "d": "M14.959 49.006h-3.331v4.142a.734.734 0 01-.756.738.73.73 0 01-.738-.738v-10.3c0-.594.486-1.08 1.081-1.08h3.745c2.413 0 3.763 1.656 3.763 3.619s-1.388 3.619-3.764 3.619zm-.18-5.905h-3.151v4.573h3.151c1.422 0 2.395-.937 2.395-2.287s-.973-2.286-2.395-2.286zm12.06 10.911c-3.421 0-6.176-2.503-6.176-6.23 0-3.727 2.754-6.212 6.176-6.212 1.8 0 3.169.685 4.123 1.639.144.126.198.324.198.504 0 .396-.288.703-.684.703a.669.669 0 01-.486-.217c-.756-.81-1.963-1.296-3.151-1.296-2.629 0-4.627 2.017-4.627 4.879 0 2.845 1.999 4.897 4.627 4.897 1.44 0 2.628-.702 3.223-1.296v-2.449h-3.583c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h3.998c.594 0 1.08.486 1.08 1.08v2.377c-.001 1.854-2.594 2.953-4.718 2.953zm11.483-.019c-1.782 0-3.187-.594-4.213-1.494a.712.712 0 01-.234-.54c0-.36.27-.757.702-.757.144 0 .306.036.432.145.828.738 1.98 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.07 0-3.098-7.112-1.387-7.112-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.468 3.853 1.278a.73.73 0 01.252.54c0 .36-.306.72-.703.72a.684.684 0 01-.432-.161c-.882-.721-1.98-1.045-3.079-1.045-1.44 0-2.467.774-2.467 1.909 0 2.7 7.112 1.152 7.112 5.635.001 1.747-1.187 3.529-4.428 3.529z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.976 20.352v1H43.177s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#4F4FDA"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    pdf: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#8C181A",
        "d": "M5.1 0C2.3 0 0 2.3 0 5.1v53.8C0 61.7 2.3 64 5.1 64h45.8c2.8 0 5.1-2.3 5.1-5.1V20.3L37.1 0h-32z"
      }, {
        "fill": "#6B0D12",
        "d": "M56 20.4v1H43.2s-6.3-1.3-6.1-6.7c0 0 .2 5.7 6 5.7H56z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37.1 0v14.6c0 1.7 1.1 5.8 6.1 5.8H56L37.1 0z"
      }, {
        "fill": "#FFF",
        "d": "M14.9 49h-3.3v4.1c0 .4-.3.7-.8.7-.4 0-.7-.3-.7-.7V42.9c0-.6.5-1.1 1.1-1.1h3.7c2.4 0 3.8 1.7 3.8 3.6 0 2-1.4 3.6-3.8 3.6zm-.1-5.9h-3.2v4.6h3.2c1.4 0 2.4-.9 2.4-2.3s-1-2.3-2.4-2.3zm10.4 10.7h-3c-.6 0-1.1-.5-1.1-1.1v-9.8c0-.6.5-1.1 1.1-1.1h3c3.7 0 6.2 2.6 6.2 6s-2.4 6-6.2 6zm0-10.7h-2.6v9.3h2.6c2.9 0 4.6-2.1 4.6-4.7.1-2.5-1.6-4.6-4.6-4.6zm16.3 0h-5.8V47h5.7c.4 0 .6.3.6.7s-.3.6-.6.6h-5.7v4.8c0 .4-.3.7-.8.7-.4 0-.7-.3-.7-.7V42.9c0-.6.5-1.1 1.1-1.1h6.2c.4 0 .6.3.6.7.1.3-.2.6-.6.6z"
      }]
    },
    ppt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112-.004A5.074 5.074 0 00.039 5.07v53.841a5.073 5.073 0 005.073 5.074h45.774a5.074 5.074 0 005.074-5.074V20.306L37.058-.004H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#E34221"
      }, {
        "d": "M14.964 49.011h-3.331v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.854c0-.594.486-1.081 1.08-1.081h3.745c2.413 0 3.763 1.657 3.763 3.619 0 1.963-1.387 3.619-3.763 3.619zm-.181-5.906h-3.15v4.573h3.15c1.423 0 2.395-.936 2.395-2.287 0-1.349-.972-2.286-2.395-2.286zm11.197 5.906h-3.332v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.854c0-.594.486-1.081 1.08-1.081h3.746c2.412 0 3.763 1.657 3.763 3.619 0 1.963-1.387 3.619-3.763 3.619zm-.18-5.906h-3.151v4.573H25.8c1.423 0 2.395-.936 2.395-2.287-.001-1.349-.972-2.286-2.395-2.286zm14.112 0h-3.277v10.047a.734.734 0 01-.756.738.73.73 0 01-.738-.738V43.105h-3.259c-.36 0-.647-.288-.647-.684 0-.361.287-.648.647-.648h8.03c.36 0 .648.288.648.685a.644.644 0 01-.648.647z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#DC3119"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    psd: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112.051A5.074 5.074 0 00.039 5.126v53.841a5.073 5.073 0 005.073 5.073h45.775a5.074 5.074 0 005.074-5.073V20.361L37.058.051H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#0C77C6"
      }, {
        "d": "M14.952 49.011h-3.331v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.854c0-.594.486-1.081 1.08-1.081h3.745c2.413 0 3.763 1.657 3.763 3.619 0 1.963-1.387 3.619-3.763 3.619zm-.181-5.906h-3.15v4.573h3.15c1.423 0 2.395-.936 2.395-2.287 0-1.349-.972-2.286-2.395-2.286zm10.26 10.894c-1.781 0-3.187-.594-4.213-1.495a.71.71 0 01-.234-.54c0-.36.271-.756.703-.756.144 0 .306.036.432.144.828.739 1.98 1.314 3.367 1.314 2.143 0 2.826-1.152 2.826-2.071 0-3.097-7.111-1.386-7.111-5.672 0-1.98 1.764-3.331 4.123-3.331 1.549 0 2.881.467 3.854 1.278a.73.73 0 01.252.54c0 .36-.307.72-.703.72a.682.682 0 01-.432-.162c-.883-.72-1.98-1.044-3.078-1.044-1.441 0-2.467.774-2.467 1.909 0 2.701 7.111 1.152 7.111 5.636 0 1.748-1.188 3.53-4.43 3.53zm11.215-.216h-3.025c-.594 0-1.08-.487-1.08-1.081v-9.849c0-.594.486-1.081 1.08-1.081h3.025c3.727 0 6.157 2.611 6.157 6.014 0 3.422-2.43 5.997-6.157 5.997zm0-10.678h-2.611v9.345h2.611c2.916 0 4.609-2.088 4.609-4.663 0-2.593-1.638-4.682-4.609-4.682z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#0959B7"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    quip_doc: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#3D87F5",
        "d": "M0 5.1v53.7C0 61.7 2.3 64 5.1 64h45.7c2.8 0 5.1-2.3 5.1-5.1V21L37 0H5.1C2.3 0 0 2.3 0 5.1z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37 0l19 21H42.1c-2.8 0-5.2-2.3-5.2-5.2L37 0z"
      }, {
        "opacity": ".5",
        "fill": "#216AC1",
        "d": "M37 15.9v1c0 2.8 2.3 5.2 5.2 5.2H56v-1H42.1c-2.8-.1-5.1-2.4-5.1-5.2z"
      }, {
        "fill": "#FFF",
        "d": "M23.5 46.7h-6.9c-.4 0-.8.3-.8.8s.3.8.8.8h6.9c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM16.5 41.3h6.9c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8h-6.9c-.4 0-.8.3-.8.8.1.5.4.8.8.8zM14.2 43.2c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h11.5c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8H14.2z"
      }, {
        "fill": "#FFF",
        "d": "M26.8 36.7c-3.9-3.7-10.1-3.6-13.9.2-3.8 3.8-3.9 10-.2 13.9 1.9 2 4.5 3.2 7.3 3.2h9.2c.4 0 .8-.3.8-.8V44c0-2.8-1.1-5.4-3.2-7.3zm1.6 15.8H20c-2.3 0-4.6-1-6.2-2.7-1.6-1.7-2.4-4-2.3-6.3.3-4.3 3.7-7.7 7.9-7.9h.5c4.7 0 8.5 3.8 8.5 8.5v8.4z"
      }]
    },
    quip_sheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#2CAB21",
        "d": "M0 5.1v53.7C0 61.7 2.3 64 5.1 64h45.7c2.8 0 5.1-2.3 5.1-5.1V21L37 0H5.1C2.3 0 0 2.3 0 5.1z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37 0l19 21H42.1c-2.8 0-5.2-2.3-5.2-5.2L37 0z"
      }, {
        "opacity": ".5",
        "fill": "#189355",
        "d": "M37 15.9v1c0 2.8 2.3 5.2 5.2 5.2H56v-1H42.1c-2.8-.1-5.1-2.4-5.1-5.2z"
      }, {
        "fill": "#FFF",
        "d": "M23.5 46.7h-6.9c-.4 0-.8.3-.8.8s.3.8.8.8h6.9c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM16.5 41.3h6.9c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8h-6.9c-.4 0-.8.3-.8.8.1.5.4.8.8.8zM14.2 43.2c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h11.5c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8H14.2z"
      }, {
        "fill": "#FFF",
        "d": "M26.8 36.7c-3.9-3.7-10.1-3.6-13.9.2-3.8 3.8-3.9 10-.2 13.9 1.9 2 4.5 3.2 7.3 3.2h9.2c.4 0 .8-.3.8-.8V44c0-2.8-1.1-5.4-3.2-7.3zM20 52.5c-2.3 0-4.6-1-6.2-2.7-1.6-1.7-2.4-4-2.3-6.3.3-4.3 3.7-7.7 7.9-7.9h.5c4.7 0 8.5 3.8 8.5 8.5v8.4H20z"
      }]
    },
    quip_slide: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8D3DF5",
        "d": "M0 5.1v53.7C0 61.7 2.3 64 5.1 64h45.7c2.8 0 5.1-2.3 5.1-5.1V21L37 0H5.1C2.3 0 0 2.3 0 5.1z"
      }, {
        "opacity": ".5",
        "fill": "#FFF",
        "d": "M37 0l19 21H42.1c-2.8 0-5.2-2.3-5.2-5.2L37 0z"
      }, {
        "opacity": ".5",
        "fill": "#6D2BD6",
        "d": "M37 15.9v1c0 2.8 2.3 5.2 5.2 5.2H56v-1H42.1c-2.8-.1-5.1-2.4-5.1-5.2z"
      }, {
        "fill": "#FFF",
        "d": "M23.5 46.7h-6.9c-.4 0-.8.3-.8.8s.3.8.8.8h6.9c.4 0 .8-.3.8-.8s-.4-.8-.8-.8zM16.5 41.3h6.9c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8h-6.9c-.4 0-.8.3-.8.8.1.5.4.8.8.8zM14.2 43.2c-.4 0-.8.3-.8.8 0 .4.3.8.8.8h11.5c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8H14.2z"
      }, {
        "fill": "#FFF",
        "d": "M26.8 36.7c-3.9-3.7-10.1-3.6-13.9.2-3.8 3.8-3.9 10-.2 13.9 1.9 2 4.5 3.2 7.3 3.2h9.2c.4 0 .8-.3.8-.8V44c0-2.8-1.1-5.4-3.2-7.3zM20 52.5c-2.3 0-4.6-1-6.2-2.7-1.6-1.7-2.4-4-2.3-6.3.3-4.3 3.7-7.7 7.9-7.9h.5c4.7 0 8.5 3.8 8.5 8.5v8.4H20z"
      }]
    },
    rtf: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.113.006A5.074 5.074 0 00.039 5.08v53.841a5.073 5.073 0 005.074 5.074h45.774a5.074 5.074 0 005.074-5.074V20.316L37.058.006H5.113z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#00A1EE"
      }, {
        "d": "M15.611 48.825l2.575 3.907a.756.756 0 01.108.378c0 .36-.306.72-.738.72a.699.699 0 01-.594-.324l-2.935-4.555h-2.395v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.793c0-.594.486-1.081 1.081-1.081h3.745c2.197 0 3.763 1.405 3.763 3.619 0 2.161-1.477 3.35-3.116 3.494zm-3.979-5.78v4.591h3.151c1.422 0 2.395-.954 2.395-2.305 0-1.35-.972-2.287-2.395-2.287h-3.151zm17.463 0h-3.277v10.047a.734.734 0 01-.756.738.73.73 0 01-.738-.738V43.045h-3.259c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h8.031c.36 0 .648.288.648.685a.647.647 0 01-.649.647zm10.295 0h-5.833v3.871h5.708c.36 0 .648.288.648.685 0 .36-.288.648-.648.648h-5.708v4.843a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.793c0-.594.486-1.081 1.081-1.081h6.248c.36 0 .648.288.648.685a.648.648 0 01-.65.648z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#0089E9"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    slide: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.15.008A5.074 5.074 0 00.078 5.082v53.842a5.072 5.072 0 005.072 5.073h45.775a5.074 5.074 0 005.074-5.073V20.318L37.096.008H5.15z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#1AB6D9"
      }, {
        "d": "M10.121 34.772v19.09h19.918v-19.09H10.121zM28.226 50.24H11.931V38.396h16.295V50.24z",
        "fill": "#fff"
      }, {
        "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#13A3CF"
      }, {
        "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
        "opacity": ".5",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }]
    },
    stypi: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.072.006A5.073 5.073 0 000 5.08v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.315L37.018.006H5.072z",
          "fill": "#DDD965"
        }, {
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#C1BC45"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }, {
          "d": "M29.399 34.802H11.768c-.872 0-1.577.706-1.577 1.577v15.99c0 .871.706 1.577 1.577 1.577h13.167l6.04-6.017v-11.55c0-.871-.705-1.577-1.576-1.577z",
          "fill": "#fff"
        }, {
          "fill": "#DBD75D",
          "d": "M13.741 43.553h13.675v1.643H13.741zm0-3.555h13.675v1.641H13.741zm0 7.109h8.867v1.643h-8.867z"
        }]
      }
    },
    txt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.151-.036A5.074 5.074 0 00.077 5.038v53.841a5.073 5.073 0 005.074 5.074h45.774a5.074 5.074 0 005.074-5.074V20.274L37.097-.036H5.151z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#F9CA06"
      }, {
        "d": "M18.763 43.045h-3.277v10.047a.734.734 0 01-.756.738.73.73 0 01-.738-.738V43.045h-3.259c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h8.03c.36 0 .648.288.648.685a.645.645 0 01-.648.647zm11.7 10.803a.64.64 0 01-.541-.27l-3.727-4.97-3.745 4.97a.639.639 0 01-.54.27.71.71 0 01-.72-.72c0-.144.036-.306.144-.432l3.889-5.131-3.619-4.826a.721.721 0 01-.144-.414c0-.343.288-.721.72-.721.216 0 .432.108.576.288l3.439 4.627 3.439-4.646a.642.642 0 01.541-.27c.378 0 .738.306.738.721a.7.7 0 01-.126.414l-3.619 4.808 3.89 5.149c.09.126.126.27.126.415a.739.739 0 01-.721.738zm11.195-10.803h-3.277v10.047a.734.734 0 01-.756.738.73.73 0 01-.738-.738V43.045h-3.259c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h8.03c.36 0 .648.288.648.685a.644.644 0 01-.648.647z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M56.008 20.316v1H43.209s-6.312-1.26-6.129-6.708c0 0 .208 5.708 6.004 5.708h12.924z",
          "fill": "#F7BC04"
        }, {
          "d": "M37.106-.036v14.561c0 1.656 1.104 5.792 6.104 5.792h12.799L37.106-.036z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    unknown: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.113.007A5.073 5.073 0 00.039 5.081v53.84a5.073 5.073 0 005.074 5.074h45.774a5.074 5.074 0 005.074-5.074V20.315L37.058.007H5.113z",
          "fill": "#8199AF"
        }, {
          "d": "M55.976 20.352v1H43.177s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#617F9B"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    video: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.15.011A5.073 5.073 0 00.078 5.085v53.841A5.073 5.073 0 005.15 64h45.775A5.075 5.075 0 0056 58.926V20.32L37.096.011H5.15z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8E4C9E"
      }, {
        "d": "M24.531 45.529c0 .368-.163.736-.449.981-.205.163-5.255 4.417-11.839 7.095a1.411 1.411 0 01-.511.103 1.35 1.35 0 01-.675-.184 1.229 1.229 0 01-.613-.981c-.021-.144-.307-3.456-.307-7.014s.286-6.87.307-6.993c.021-.408.266-.776.613-1.002.205-.122.43-.184.675-.184.164 0 .348.041.511.103 6.584 2.678 11.634 6.932 11.839 7.115.286.225.449.593.449.961z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#713985"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    visio: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.111.006A5.073 5.073 0 00.039 5.08v53.841a5.073 5.073 0 005.072 5.074h45.775a5.074 5.074 0 005.074-5.074V20.315L37.057.006H5.111z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#496AB3"
      }, {
        "d": "M20.915 42.686l-4.16 10.334c-.198.486-.684.81-1.188.81h-.036a1.316 1.316 0 01-1.207-.81l-4.141-10.334a.755.755 0 01-.054-.289c0-.36.324-.792.811-.792.306 0 .594.181.72.486l3.889 9.993 3.889-9.993a.767.767 0 01.72-.486c.468 0 .81.378.81.792 0 .09-.018.198-.053.289zm3.147 11.144a.73.73 0 01-.738-.738V42.325c0-.396.324-.721.774-.721.396 0 .72.324.72.721v10.767a.734.734 0 01-.756.738zm7.902.108c-1.782 0-3.187-.594-4.213-1.495a.71.71 0 01-.234-.54c0-.36.27-.756.702-.756.144 0 .306.036.432.145.829.738 1.981 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.071 0-3.097-7.112-1.386-7.112-5.672 0-1.98 1.764-3.33 4.123-3.33 1.548 0 2.881.467 3.853 1.277a.731.731 0 01.252.541c0 .359-.306.72-.702.72a.68.68 0 01-.432-.162c-.882-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636.001 1.746-1.188 3.528-4.429 3.528z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#374FA0"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    webex: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M5.152.011A5.074 5.074 0 00.078 5.085v53.841A5.074 5.074 0 005.152 64h45.773A5.075 5.075 0 0056 58.926V20.32L37.098.011H5.152z",
          "fill": "#80BC4B"
        }, {
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#60AB38"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": [{
        "d": "M20.463 53.854c5.161-.271 9.261-4.538 9.261-9.767a9.78 9.78 0 00-9.26-9.767l-.001 19.534z",
        "fill": "#CFE8AF"
      }, {
        "d": "M19.338 53.852c-5.119-.316-9.174-4.565-9.174-9.764s4.056-9.447 9.174-9.763v19.527z",
        "fill": "#fff"
      }]
    },
    word: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "path": [{
          "d": "M5.11 0A5.07 5.07 0 000 5v53.88A5.07 5.07 0 005.11 64h45.78A5.07 5.07 0 0056 58.88v-38.6L37.06 0z",
          "fill": "#107cad"
        }, {
          "d": "M56 20.35v1H43.18s-6.31-1.26-6.13-6.71c0 0 .21 5.71 6 5.71z",
          "fill": "#084968"
        }, {
          "d": "M37.07 0v14.56a5.78 5.78 0 006.11 5.79H56z",
          "fill": "#90d0fe",
          "opacity": ".5"
        }]
      },
      "path": {
        "d": "M14.24 53.86h-3a1.08 1.08 0 01-1.08-1.08v-9.85a1.08 1.08 0 011.08-1.08h3a6 6 0 110 12zm0-10.67h-2.61v9.34h2.61a4.41 4.41 0 004.61-4.66 4.38 4.38 0 00-4.61-4.68zm14.42 10.89a5.86 5.86 0 01-6-6.21 6 6 0 1111.92 0 5.87 5.87 0 01-5.92 6.21zm0-11.09c-2.7 0-4.41 2.07-4.41 4.88s1.71 4.88 4.41 4.88 4.41-2.09 4.41-4.88S31.35 43 28.66 43zm18.45.38a.75.75 0 01.2.52.71.71 0 01-.7.72.64.64 0 01-.51-.24 4.06 4.06 0 00-3-1.38 4.61 4.61 0 00-4.63 4.88 4.63 4.63 0 004.63 4.88 4 4 0 003-1.37.7.7 0 01.51-.24.72.72 0 01.7.74.78.78 0 01-.2.51 5.33 5.33 0 01-4 1.69 6.22 6.22 0 010-12.43 5.26 5.26 0 014 1.72z",
        "fill": "#fff"
      }
    },
    xml: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.112-.024A5.074 5.074 0 00.038 5.05v53.841a5.073 5.073 0 005.074 5.074h45.774a5.074 5.074 0 005.074-5.074V20.285L37.058-.024H5.112z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FC7B24"
      }, {
        "d": "M19.371 53.848a.64.64 0 01-.541-.27l-3.727-4.97-3.745 4.97a.638.638 0 01-.54.27.712.712 0 01-.721-.72.66.66 0 01.145-.432l3.889-5.131-3.619-4.826a.721.721 0 01-.144-.414c0-.343.288-.721.72-.721.217 0 .433.108.576.288l3.439 4.627 3.439-4.646a.64.64 0 01.54-.27c.378 0 .737.306.737.721a.7.7 0 01-.125.414l-3.619 4.808 3.889 5.149c.09.126.127.27.127.415a.736.736 0 01-.72.738zm14.455-.018a.73.73 0 01-.738-.738v-9.254l-4.033 9.759c-.055.143-.2.233-.379.233a.37.37 0 01-.342-.234l-4.016-9.759v9.254a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.829c0-.648.559-1.207 1.242-1.207.486 0 .99.288 1.188.756l3.438 8.373 3.457-8.373c.199-.468.686-.756 1.189-.756.684 0 1.242.558 1.242 1.207v10.263c.002.414-.322.738-.754.738zm10.546-.108h-5.456c-.594 0-1.08-.486-1.08-1.081V42.325c0-.396.324-.721.774-.721.396 0 .72.324.72.721V52.39h5.042c.36 0 .647.288.647.648.001.396-.287.684-.647.684z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#FB5C1B"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    zip: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M5.113-.026A5.074 5.074 0 00.039 5.048v53.841a5.073 5.073 0 005.074 5.074h45.773a5.074 5.074 0 005.074-5.074V20.284L37.059-.026H5.113z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8199AF"
      }, {
        "d": "M18.438 53.906h-7.581c-.378 0-.756-.342-.756-.828 0-.18.054-.36.162-.504l6.68-9.345h-6.212c-.36 0-.648-.288-.648-.684 0-.36.288-.648.648-.648h7.454c.378 0 .756.342.756.829 0 .18-.054.36-.162.504l-6.68 9.345h6.338c.36 0 .648.288.648.648.001.395-.287.683-.647.683zm4.012.108a.73.73 0 01-.738-.738V42.509c0-.396.324-.721.774-.721.396 0 .72.324.72.721v10.767a.735.735 0 01-.756.738zm8.839-4.879h-3.331v4.141a.734.734 0 01-.756.738.73.73 0 01-.738-.738V42.977c0-.594.486-1.081 1.081-1.081h3.745c2.413 0 3.763 1.657 3.763 3.619s-1.387 3.62-3.764 3.62zm-.18-5.906h-3.151v4.573h3.151c1.422 0 2.395-.936 2.395-2.287-.001-1.35-.973-2.286-2.395-2.286z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M55.977 20.352v1H43.178s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
          "fill": "#617F9B"
        }, {
          "d": "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799L37.074 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    viewBox: '0 0 56 64'
  };
}

export default icons;